module.exports = __webpack_public_path__ + "static/media/KaTeX_Caligraphic-Bold.33d26881.ttf";